<template>
<span class="amf-primitive">
<div style="position:relative">
    <label class="amf-input-label" v-if="$_showLabel">{{label}}</label>

    <div class="input-group">
      <!-- <input v-if="mask" :class="['form-control', { error: hasError }]" type="text"
           v-model.lazy="maskedValue" disabled :placeholder="placeholder" :title="title || label" /> -->
      <input :class="['form-control', { error: hasError }]" type="text" :maxlength="maxLength"
           v-model.lazy="maskedValue" :placeholder="placeholder" :title="title || label" :disabled="$_disabled || maskOn" />
      <div class="input-group-append" @click="() => { maskOn = !maskOn }">
        <span class="input-group-text">
          <span v-if="maskOn" class="fa fa-pencil"></span>
          <span v-else class="fa fa-eye-slash"></span>
        </span>
      </div>
    </div>

    <div class="error-div">
        {{validationMessage}}
    </div>
</div>

</span>
</template>

<script>
import primitiveMixin from './primitive-mixin'
import { v } from "framework";

export default {
    mixins: [primitiveMixin],
    props: {
        label: String,
        value: {},
        title: { type: String, required: false },
        maskFunc: { type: Function, required: true},
        maxLength: { type: Number, required: false },
    },
    data() {
        return {
            internalValue: this.value && this.value.$model ? this.value.$model : this.value,
            maskOn: true
        }
    },
    computed: {
      maskedValue: {
        get() {
          if (!this.maskOn) return this.internalValue;
          return this.maskFunc(this.internalValue);
        },
        set: function (v) {
          this.internalValue = v;
        }
      },
    },
    watch: {
        value(newValue) {
            this.internalValue = newValue;
        },
        internalValue(newValue) {
            this.changeMade({
                name: this.label,
                value: this.internalValue
            });
            // console.log("emit " + newValue);
            if (newValue === "" || newValue === null) {
                this.$emit("input", null);
            } else {
                this.$emit("input", newValue);
            }
        },
    },
    methods: {
    },
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/framework/primitives/AmfSecureInput.vue